import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../core/error-dialog/error-dialog.component';
import { AlertDialogComponent } from '../components/shared/components/alert-dialog/alert-dialog.component';
import { NotificationService } from './notificationservice';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private injector: Injector, private dialog: MatDialog, private notificationService: NotificationService) { }

  handleError(error: any): void {
    console.error('Global error caught:', error);

    const dialog = this.injector.get(MatDialog);
    //this.notificationService.show(error?.message || 'An unexpected error occurred.', 'Exception');
    // this.dialog.open(AlertDialogComponent, {
    //   data: {
    //     title: 'Exception',
    //     message: error?.message || 'An unexpected error occurred.'
    //   }
    // });
    // dialog.open(ErrorDialogComponent, {
    //   data: {
    //     message: error?.message || 'An unexpected error occurred.',
    //     stack: error?.stack || ''
    //   }
    // });
  }
  showError(message: string, title: string = 'An Unexpected Error Occurred'): void {
    this.notificationService.show(message, 'error');
  }
}